import React from 'react';
import { Modal, Button } from 'react-bootstrap';

import s from '../Footer/ConfirmRestartModal.module.scss';

interface ConfirmClearExportsModalProps {
  showModal: boolean;
  clearExports: () => void;
  closeModal: () => void;
}

class ConfirmClearExportsModal extends React.Component<ConfirmClearExportsModalProps> {
  render() {
    return (
      <div>
        <Modal
          centered
          show={this.props.showModal}
          backdrop="static"
          dialogClassName={s.restartModal}
        >
          <Modal.Header className={s.header}>
            <Modal.Title>
              <h3>
                <strong>Exporte löschen?</strong>
              </h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className={s.body}>
            Dadurch werden alle gespeicherten Exporte unwiderruflich gelöscht.
          </Modal.Body>
          <Modal.Footer className={s.footer}>
            <Button variant="btn btn-secondary" onClick={this.props.closeModal}>
              ABBRECHEN
            </Button>
            <Button variant="btn btn-primary" onClick={this.props.clearExports}>
              LÖSCHEN
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default ConfirmClearExportsModal;
